import { render, staticRenderFns } from "./ViewOnboarding.vue?vue&type=template&id=33d4e2f4&scoped=true&"
import script from "./ViewOnboarding.vue?vue&type=script&lang=ts&"
export * from "./ViewOnboarding.vue?vue&type=script&lang=ts&"
import style0 from "./ViewOnboarding.vue?vue&type=style&index=0&id=33d4e2f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d4e2f4",
  null
  
)

export default component.exports